import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LocationWork } from '../interfaces/location-work.interface';

/* === Added client-side DTOs to match API controller === */
export interface ImportLocationData {
  lineNumber: number;
  locationName: string;
  address1: string;
  address2?: string;
  city: string;
  state?: string;
  postalCode?: string;
  country: string;
  userLocationNumber?: string;
}

export interface BulkImportRequest {
  locations: ImportLocationData[];
  organizationId: number;
  organizationName: string;
  timeZoneId: number;
  userId: number;
  userName: string;
  userLocationNumber?: string;
  fileName: string;
  fileDate: Date;
  billableOrganizationID: number; // <-- nuevo
}

export interface ImportResult {
  lineNumber: number;
  locationName: string;
  locationId: string;
  address1: string;
  address2?: string;
  city: string;
  state?: string;
  postalCode?: string;
  country: string;
  organizationName: string;            
  destinationOrganizationName?: string; 
  timeStamp: Date;
  userName: string;
  status: string; // "Success" | "Error" | "Pending" | "Processing"
  errorMessage?: string;
  userLocationNumber?: string;
  workId?: number;
}

export interface BulkImportResponse {
  results: ImportResult[];
  totalProcessed: number;
  successCount: number;
  errorCount: number;
  message: string;
}
/* === end DTOs === */

@Injectable({ providedIn: 'root' })
export class LocationWorkService {
  constructor(private http: HttpClient) { }
  private readonly apiURL: string = 'api/v1/LocationWork';

  getByOrganization(organizationId: number): Observable<LocationWork[]> {
    return this.http.get<LocationWork[]>(`${this.apiURL}/by-organization/${organizationId}`);
  }

  create(locationWork: LocationWork): Observable<LocationWork> {
    return this.http.post<LocationWork>(`${this.apiURL}`, locationWork);
  }

  update(locationWork: LocationWork): Observable<LocationWork> {
    return this.http.put<LocationWork>(`${this.apiURL}/${locationWork.locationWorkId}`, locationWork);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiURL}/${id}`);
  }

  deleteRows(billableOrgId: number, workIds: number[]): Observable<{ deletedCount: number }> {
    return this.http.post<{ deletedCount: number }>(
      this.apiURL + '/delete-rows/' + billableOrgId, { workIds }
    );
  }

  bulkImport(request: BulkImportRequest): Observable<BulkImportResponse> {
    return this.http.post<BulkImportResponse>(`${this.apiURL}/bulk-import`, request);
  }

  bulkCreateLocationsFromWork(payload: {
    workIds: number[];
    isShipTo: boolean;
    timeZoneId: number;
    primaryContactId?: number;
    daylightSavings?: boolean;
  }): Observable<any> {
    return this.http.post<any>(`${this.apiURL}/bulk-create-locations-from-work`, payload);
  }
}
